import { ShieldCheck, Zap, Star, Users, Lock, Award } from "lucide-react";

const pillars = [
  {
    icon: ShieldCheck,
    title: "100% Nezávislost",
    desc: "Hodnotíme bez sponzorského tlaku. Jen fakta.",
  },
  {
    icon: Zap,
    title: "Aktuální data",
    desc: "Nabídky ověřujeme každý den, aby byly přesné.",
  },
  {
    icon: Star,
    title: "Expertní recenze",
    desc: "Tým zkušených hráčů s léty zkušeností.",
  },
  {
    icon: Users,
    title: "Komunita hráčů",
    desc: "Denně pomáháme hráčům najít to nejlepší.",
  },
  {
    icon: Lock,
    title: "Bezpečné weby",
    desc: "Pouze kasina s platnou licencí.",
  },
  {
    icon: Award,
    title: "Top bonusy",
    desc: "Vyjednáváme exkluzivní nabídky jen pro vás.",
  },
];

export function TrustBar() {
  return (
    <section className="bg-white py-16 border-b border-gray-100" data-testid="section-trust">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16">
        <div className="text-center mb-12">
          <p className="text-[#003da5] font-semibold text-sm uppercase tracking-widest mb-2">
            Proč HrajBonus
          </p>
          <h2 className="text-3xl font-black text-gray-900">
            Váš průvodce světem online kasin
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {pillars.map((p, i) => (
            <div
              key={p.title}
              className="flex flex-col items-center text-center gap-3 group cursor-default"
              data-testid={`pillar-${i}`}
            >
              <div className="w-12 h-12 rounded-xl bg-[#003da5]/8 flex items-center justify-center group-hover:bg-[#003da5]/15 transition-colors duration-200">
                <p.icon className="w-6 h-6 text-[#003da5]" />
              </div>
              <div>
                <div className="font-bold text-gray-900 text-sm leading-snug">{p.title}</div>
                <div className="text-gray-500 text-xs mt-1 leading-snug">{p.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
